import { CreateFoodStockCase } from './domain/useCases/CreateFoodStockCase'
import { CreateFoodStockFoodCase } from './domain/useCases/CreateFoodStockFoodCase'
import { CreateFoodStockFoodItemCase } from './domain/useCases/CreateFoodStockFoodItemCase'
import { CreateItemFoodStock } from './domain/useCases/CreateItemFoodStockCase'
import { DeleteFoodStockCase } from './domain/useCases/DeleteFoodStockCase'
import { DeleteFoodStockFoodItemCase } from './domain/useCases/DeleteFoodStockFoodItemCase'
import { DeleteFoodStockItemCase } from './domain/useCases/DeleteFoodStockItemCase '
import { ListAllPatientsFoodStockCase } from './domain/useCases/ListAllPatientsFoodStockCase'
import { ListPatientFoodStockCase } from './domain/useCases/ListPatientFoodStockCase'
import { UpdateFoodStockMinimumQuantityCase } from './domain/useCases/UpdateFoodStockMinimumQuantityCase'
import { foodStockDatasource } from './external/datasources/foodStockDatasource'
import { foodStockRepository } from './infra/repositories/foodStockRepository'

const createFoodStockCase = CreateFoodStockCase(
  foodStockRepository(foodStockDatasource)
)
const updateFoodStockMinimumQuantityCase = UpdateFoodStockMinimumQuantityCase(
  foodStockRepository(foodStockDatasource)
)
const listAllPatientsFoodStockCase = ListAllPatientsFoodStockCase(
  foodStockRepository(foodStockDatasource)
)
const listPatientFoodStockCase = ListPatientFoodStockCase(
  foodStockRepository(foodStockDatasource)
)
const deleteFoodStockCase = DeleteFoodStockCase(
  foodStockRepository(foodStockDatasource)
)
const createFoodStockFoodCase = CreateFoodStockFoodCase(
  foodStockRepository(foodStockDatasource)
)
const createFoodStockFoodItemCase = CreateFoodStockFoodItemCase(
  foodStockRepository(foodStockDatasource)
)
const deleteFoodStockFoodItemCase = DeleteFoodStockFoodItemCase(
  foodStockRepository(foodStockDatasource)
)
const deleteFoodStockItemCase = DeleteFoodStockItemCase(
  foodStockRepository(foodStockDatasource)
)
const createItemFoodStock = CreateItemFoodStock(
  foodStockRepository(foodStockDatasource)
)
export const foodStockInstance = {
  createFoodStockCase,
  updateFoodStockMinimumQuantityCase,
  listAllPatientsFoodStockCase,
  listPatientFoodStockCase,
  deleteFoodStockCase,
  createFoodStockFoodCase,
  createFoodStockFoodItemCase,
  deleteFoodStockFoodItemCase,
  deleteFoodStockItemCase,
  createItemFoodStock
}
